module.exports = __webpack_public_path__ + "static/media/download.23c24289.svg";